<script>
import { layoutComputed } from '@state/helpers'
import Vertical from '@router/layouts/vertical'
import appConfig from '@src/app.config'
import Loading from '@components/local-loading'
const apiDomain = appConfig.apiDomain

export default {
  components: { Vertical, Loading },
  data() {
    return {
      deleteEndpoint: null,
      showDeleteModal: false,
    }
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    this.$root.$on('on-delete-record', (url) => {
      if (url) this.showDeleteModal = true
      this.deleteEndpoint = url
    })
  },
  methods: {
    hideDeleteModal() {
      this.showDeleteModal = false
    },
    deleteRecord() {
      this.$http
        .post(apiDomain + this.deleteEndpoint)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$root.$emit('on-delete-record-success')
            this.$toastr.s('deleted record successfully', 'Delete Record')
          } else {
            var message = 'delete record error'
            if (response.data.message) message = response.data.message
            this.$toastr.e(message, 'Delete Record')
          }
          this.showDeleteModal = false
        })
        .catch(() => {
          this.$toastr.e('delete record error', 'Delete Record')
          this.showDeleteModal = false
          return null
        })
    },
  },
}
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>
    <Loading v-if="loading" />
    <!--modal change add new group-->
    <b-modal
      v-model="showDeleteModal"
      title="Delete"
      title-class="text-black font-18"
      hide-footer
    >
      <form @submit.prevent="deleteRecord">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name"
                >Are you sure You want to delete this record?</label
              >
            </div>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-success">Yes</button>
          <b-button class="ml-1" variant="light" @click="hideDeleteModal"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
  </div>
</template>
